var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGererMonSite = function SvgIconGererMonSite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-gerer-mon-site",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-589.206 -85.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "browser"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M601.955 88.1h-11.5a1.251 1.251 0 0 0-1.252 1.252V92.1h14v-2.745a1.251 1.251 0 0 0-1.248-1.255Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(590.706 89.604)",
    fill: "#f54c3c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(593.206 89.604)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(595.706 89.604)",
    fill: "#8ccd32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    transform: "translate(589.206 92.104)",
    fill: "#bee6fa",
    d: "M0 0h14v8H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "m598.99 92.949-.708 2.829 2.829-.708L605 91.184l-2.121-2.121Z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M606.767 87.293a1.494 1.494 0 0 0-2.117 0l-.708.708 2.122 2.121.7-.7a1.5 1.5 0 0 0 .003-2.129Z",
    fill: "#ffb49d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    transform: "rotate(45 195.742 773.018)",
    fill: "#505050",
    d: "M0 0h3v1.501H0z"
  })))));
};
export { SvgIconGererMonSite as ReactComponent };
export default "data:image/svg+xml;base64,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";